





















































































































import { Component, Vue } from "vue-property-decorator";
import qr_scansModule from "@/store/modules/qr_scans-module";
import qrsModule from "@/store/modules/qrs-module";
import { qr_scans } from "@/shared/dtos/qr_scans";
import { qrs } from "@/shared/dtos/qrs";
import { UtilsURLS } from "@/utils/utils-urls";

@Component({})
export default class verify_token extends Vue {
  private token: string | null = null;
  private scan: qr_scans | null = null;
  private qr: qrs | null = null;
  private loading = true;
  private saving = false;
  private showDetails = false;

  private readonly MIN_VALID_VERIFIED_AT = new Date("1900-01-01T00:00:00Z");

  async mounted() {
    await this.init();
  }

  private async init() {
    try {
      this.loading = true;
      const fromQuery =
        this.$route.query.token ||
        (this.$route && (this.$route.params as any).token);
      this.token = (fromQuery as string) || null;
      if (!this.token) return;

      // cargar scans y buscar por token
      await qr_scansModule.getqr_scanses();
      const all = qr_scansModule.qr_scanses || [];
      const found =
        all.find((s) => s && (s as any).verification_token === this.token) ||
        null;
      this.scan = found ? new qr_scans(found) : null;
      if (!this.scan) return;

      // si no estaba verificado, marcar verified_at ahora
      const v = (this.scan as any).verified_at;
      const alreadyVerified = v && new Date(v) > this.MIN_VALID_VERIFIED_AT;
      if (!alreadyVerified) {
        const updated = new qr_scans({
          ...(this.scan as any),
          verified_at: new Date(),
        });
        await qr_scansModule.modificarqr_scans(updated);
        this.scan = updated;
      }

      // cargar qrs asociado
      await qrsModule.getqrses();
      const allQrs = qrsModule.qrses || [];
      const q =
        allQrs.find((x) => x && (x as any).id === (this.scan as any).qr_id) ||
        null;
      this.qr = q ? new qrs(q) : null;
    } catch (err) {
      console.error("verify_token.init error:", err);
    } finally {
      this.loading = false;
    }
  }
  get isRedeemed(): boolean {
    if (!this.qr) return false;
    return !!(this.qr as any).redeemed;
  }
  // background style computed (uses provided image file in /src/assets)
  get bgStyle() {
    // require the image so webpack includes it
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const img = UtilsURLS.urls("/assets/images/fondo_vappers.jpeg");
    return {
      backgroundImage: `linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.35)), url(${img})`,
      backgroundSize: "cover",
      backgroundPosition: "center center",
      minHeight: "100vh",
    } as any;
  }
}
